/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { GetSettingsServiceByIdApiArg, SettingsServiceItem } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSettingsServiceById: build.query<SettingsServiceItem, GetSettingsServiceByIdApiArg>({
      query: (queryArg) => ({
        method: 'GET',
        url: `/v1/settings/services/${queryArg.serviceId}`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getSettingsServiceByIdApi };
export const { useGetSettingsServiceByIdQuery, useLazyGetSettingsServiceByIdQuery } = injectedRtkApi;
